import { Bulto } from "./Exportacion/Bulto";

export class ExportacionTransporteDte {
	haveTransport: boolean;
	tara: number;
	medidaTara: number;
	pesoNeto: number;
	pesoBruto: number;
	medidaPesoBruto: number;
	medidaPesoNeto: number;
	tipoBulto: string;
	totalBultos: string;
	flete: number;
	seguro: number;
	viaTransporte: string;
	paisReceptor: string;
	paisEmisor: string;
	puertoEmbarque: number;
	puertoDesembarque: number;
	listaBultos: Bulto[];
	codigoPaisReceptor: number;
	codigoPaisDestino: number;
	codigoPuertoEmbarque: number;
	codigoPuertoDesembarque: number;
	codigoViaTransporte: number;
	territorioEmbarque: string;
	territorioDesembarque: string;
	nombreTransporte: string;
	formaPagoExportacion: string;
	formaPagoExportacionEnum: number;
}
